import { Component, Output, EventEmitter, Input, Injector, Inject } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';
import { DataService } from 'src/app/services/data.service';
import { Event, NavigationStart, Router } from '@angular/router';
import { StrappiService } from 'src/app/services/strappi.service';
import { catchError, map, of } from 'rxjs';
import { KeycloakCustomService } from 'src/app/services/keycloak-custom.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { WINDOW } from 'src/app/utils/window';

@Component({
  selector: 'app-main-header',
  templateUrl: `./main-header.component${environment.templateSuffix}.html`,
  styleUrls: ['./main-header.component.scss'],
})
export class MainHeaderComponent {
  @Output() public sidenavToggle = new EventEmitter();
  @Input() userObject!: any;
  @Input() isLoged!: any;
  @Input() idKeycloak!: any;
  @Input() processActive!: any;

  urlLocation: boolean = false;
  urlComparator: boolean = false;
  logoPrincipal: string = '';

  public dataService: DataService;
  public matIconRegistry: MatIconRegistry;
  public domSanitizer: DomSanitizer;

  constructor(
    public keycloackService: KeycloakService,
    public keycloakCustomService: KeycloakCustomService,
    @Inject(DOCUMENT) private document: any,
    @Inject(WINDOW) private window: any,
    public router: Router,
    private injector: Injector,
    private strapi: StrappiService


  ) {
    this.dataService = this.injector.get<DataService>(DataService);
    this.matIconRegistry = this.injector.get<MatIconRegistry>(MatIconRegistry);
    this.domSanitizer = this.injector.get<DomSanitizer>(DomSanitizer);

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.urlLocation = event.url.includes('genera-oportunidad');
        this.urlComparator = event.url.includes('comparar-unidad');
      }
    });

    this.getLogoHeader();

    this.matIconRegistry.addSvgIcon('flag-mex', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/img/lang/leasing-header-flag.svg"));
  }

  public onToggleSidenav = () => {
    this.sidenavToggle.emit();
  };

  public logout() {
    sessionStorage.removeItem('aceptProcess');
    this.dataService.setIdKeycloak('');
    localStorage.removeItem('dataQuote');
    const isSalesforceLoggin = this.keycloakCustomService.isLoggin();
    if (isSalesforceLoggin) {
      this.keycloakCustomService.logout(environment.keycloak.redirectUri);
    } else {
      this.keycloackService.logout(environment.keycloak.redirectUri);
    }
  }

  goToLastStep() {
    this.router.navigate(['/genera-oportunidad']);
  }

  getClassCSS(): any {
    return this.processActive ? 'active' : 'inactive';
  }

  goComparator() {
    this.router.navigate(['/comparar-unidad']);
  }

  login() {
    localStorage.setItem('flowType', environment.templateSuffix === '' ? 'A' : 'B');
    this.keycloackService.login();
  }

  /**
   * Navega a la sección de preguntas frecuentes
   * @memberof MainHeaderComponent
   */
  goToFaq() {
    this.router.navigate(['/landing'], { fragment: 'faqs' });
  }

  /**
   * Obtiene el Logotipo del Header desde Straapi
   * @memberof MainHeaderComponent
   * @author: victor.mendez
   */
  getLogoHeader() {
    this.strapi.getImagesGeneral().pipe(
      map(data => {
        const image = data.imagenes_general.find(a => a.tipo === "logotipo_header")?.image[0];
        return image ? `${environment.strappiUrl}${image.url}` : './assets/img/logo_bitcar.svg';
      }),
      catchError(e => {
        console.error(`Error occurred while fetching data from Strapi: ${e}`);
        return of('./assets/img/logo_bitcar.svg');
      })
    ).subscribe((url: string) => {
      this.logoPrincipal = url;
    });
  }

  /**
   *
   *
   * @param {string} path
   * @memberof MainHeaderComponent
   * @author: victor.mendez
   */
  clickScroll(path: string) {

    if (this.router.url.includes('home')) {
      this.document.getElementById(path)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      this.router.navigate(['/home'], { fragment: path });
    }

  }

}
